/**
 * Handles progress bar calculation using different methods
 * @param {String} method - The calculation method ('asymptotic' or 'circle')
 * @param {Number} question_number - The current question
 * @param {Number} max_questions - The maximum number of questions
 * @returns {Number} progress - A value between 0 and 1 indicating progress
 */
export const calculate_progress = (method = 'asymptotic', question_number, max_questions) => {
    const normalized_question = question_number / max_questions;
    let progress;

    if (method === 'asymptotic') { //asymptotic scales to alpha
        const alpha = 3.0;
        progress = 1 - Math.exp(-alpha * normalized_question);
    } else { // Circle curvature
        progress = Math.sqrt(1 - Math.pow((normalized_question - 1), 2));
    }

    return progress;
};
